import { defineComponent as _defineComponent } from 'vue'
import { User, AppMode, Release } from "@/CodegenTypes";
import { queries } from "@/apollo";
import SafeMarkdown from "@/components/common/SafeMarkdown.vue";
import { chain } from "lodash";
import { customMoment } from "@/main";
import { useRootStore } from "@/store/pinia";
import { computed, onMounted, onUnmounted } from "vue";
import { useRouter } from "vue-router/composables";
import { useQuery } from "@vue/apollo-composable";
import { useTranslation } from "@/store/translation";
import { useTncQuery } from "@/api/settingsQueries";




export default /*#__PURE__*/_defineComponent({
  __name: 'TNC',
  setup(__props) {

const { result: meResult, loading: meLoading } = useQuery<{ me: User }>(queries.me)
const { data: tnc, isLoading: tncLoading } = useTncQuery()
const { result: ttReleasesResult, loading: ttReleasesLoading } = useQuery<{ releases: Release[] }>(queries.releases, { appMode: "TT" })
const { result: ddReleasesResult, loading: ddReleasesLoading } = useQuery<{ releases: Release[] }>(queries.releases, { appMode: "DD" })
const tncResult = computed(() => tnc.value !== undefined ? { tnc: tnc.value } : null);


const { $t } = useTranslation();


const router = useRouter()
const loading = computed(
  () =>
    meLoading.value ||
    tncLoading.value ||
    ttReleasesLoading.value ||
    ddReleasesLoading.value
);
const earliestEligibleRelease = computed(() => {
  const ddReleases = ddReleasesResult.value?.releases;
  const ttReleases = ttReleasesResult.value?.releases;
  if (!ddReleases || !ttReleases) return null;

  return chain([...ddReleases, ...ttReleases])
    .filter(
      (r) =>
        !r.isOver ||
        customMoment(r.releaseDate)
          .startOf("day")
          .isSame(customMoment().startOf("day"))
    )
    .filter((r) => {
      if (!meResult.value?.me.ddEnabled && r.appMode === AppMode.Dd) {
        return false;
      }
      if (!meResult.value?.me.ttEnabled && r.appMode === AppMode.Tt) {
        return false;
      }
      return true;
    })
    .sortBy((r) => customMoment(r.releaseDate).unix())
    .first()
    .value();
})


function clickAgree() {
  const earliestReleaseAppMode = earliestEligibleRelease.value?.appMode;
  if (!earliestReleaseAppMode) {
    return;
  }
  useRootStore().appMode = earliestReleaseAppMode;

  router.push({ name: "home" });
}


function clickDisagree() {
  useRootStore().logout();
  router.push({ name: "login" });
}

function keyPressHandler(e: KeyboardEvent) {
  switch (e.code) {
    case "Enter":
      clickAgree();
      break;
    case "Escape":
      clickDisagree();
      break;
  }
}

onUnmounted(() => {
  window.removeEventListener("keydown", keyPressHandler);
})


onMounted(() => {
  window.addEventListener("keydown", keyPressHandler);
})


return { __sfc: true,meResult, meLoading, tnc, tncLoading, ttReleasesResult, ttReleasesLoading, ddReleasesResult, ddReleasesLoading, tncResult, $t, router, loading, earliestEligibleRelease, clickAgree, clickDisagree, keyPressHandler, SafeMarkdown }
}

})